import { BankTransactionStatusFilter } from '@features/bankTransactions/enums/bankTransactionStatusFilter'

export interface StatusFilterButton {
  status: BankTransactionStatusFilter
  label: string
}

export const statusFilterButtons: StatusFilterButton[] = [
  { status: BankTransactionStatusFilter.All, label: 'bank_transactions.filter.all' },
  { status: BankTransactionStatusFilter.ToReview, label: 'bank_transactions.filter.need_review' },
  { status: BankTransactionStatusFilter.Reviewed, label: 'bank_transactions.filter.marked_as_ready' },
]
